import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import { BulletedNumber } from "~/styles/index.styles";
import Icon from "~/core/scripts/components/Icon";

const ElectorWrapper = styled.figure`
  margin: 24px 0 12px;
  padding: 0 12px 0 0;
  display: inline-block;
  position: relative;
  transition: color 250ms 250ms;

  svg {
    width: 24px;
    height: 32.6px;
  }

  ${({ theme }) => theme.breakpoints.sm.down} {
    svg {
      width: 20px;
      height: 27.2px;
    }
  }
`;

const BulletedNumberWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translateX(-35%) translateY(40%);
`;

function Elector({ number = 1, color = "#333333" }) {
  return (
    <ElectorWrapper style={{ color }}>
      <Icon type="congressman" />
      <BulletedNumberWrapper>
        <BulletedNumber>
          <span>{number}</span>
        </BulletedNumber>
      </BulletedNumberWrapper>
    </ElectorWrapper>
  );
}

Elector.propTypes = {
  /** Number that should be shown in the bulleted number */
  number: PropTypes.number,
  /** Background color of the elector icon */
  color: PropTypes.string,
};

export default Elector;
